export default function Loading() {
  return (
    <svg
      width="557"
      height="572"
      viewBox="0 0 557 572"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 0.4; }
            50% { opacity: 0.8; }
            100% { opacity: 0.4; }
          }
          rect {
            animation: pulse 1.5s ease-in-out infinite;
          }
        `}
      </style>
      <rect width="557" height="572" fill="white" />
      <rect x="18" y="18" width="156" height="19" rx="3" fill="#ECEFF3" />
      <rect x="18" y="60.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="466"
        y="55"
        width="30"
        height="417"
        rx="3"
        transform="rotate(90 466 55)"
        fill="#ECEFF3"
      />
      <rect x="18" y="108.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="405"
        y="103"
        width="30"
        height="356"
        rx="3"
        transform="rotate(90 405 103)"
        fill="#ECEFF3"
      />
      <rect x="18" y="156.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="358"
        y="151"
        width="30"
        height="309"
        rx="3"
        transform="rotate(90 358 151)"
        fill="#ECEFF3"
      />
      <rect x="18" y="204.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="320"
        y="199"
        width="30"
        height="271"
        rx="3"
        transform="rotate(90 320 199)"
        fill="#ECEFF3"
      />
      <rect x="18" y="252.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="281"
        y="247"
        width="30"
        height="232"
        rx="3"
        transform="rotate(90 281 247)"
        fill="#ECEFF3"
      />
      <rect x="18" y="300.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="242"
        y="295"
        width="30"
        height="193"
        rx="3"
        transform="rotate(90 242 295)"
        fill="#ECEFF3"
      />
      <rect x="18" y="348.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="209"
        y="343"
        width="30"
        height="160"
        rx="3"
        transform="rotate(90 209 343)"
        fill="#ECEFF3"
      />
      <rect x="18" y="396.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="205"
        y="391"
        width="30"
        height="156"
        rx="3"
        transform="rotate(90 205 391)"
        fill="#ECEFF3"
      />
      <rect x="18" y="444.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="179"
        y="439"
        width="30"
        height="130"
        rx="3"
        transform="rotate(90 179 439)"
        fill="#ECEFF3"
      />
      <rect x="18" y="492.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        x="125"
        y="487"
        width="30"
        height="76"
        rx="3"
        transform="rotate(90 125 487)"
        fill="#ECEFF3"
      />
      <rect x="49" y="535" width="32" height="19" rx="3" fill="#ECEFF3" />
      <rect x="140" y="535" width="32" height="19" rx="3" fill="#ECEFF3" />
      <rect x="231" y="535" width="32" height="19" rx="3" fill="#ECEFF3" />
      <rect x="322" y="535" width="32" height="19" rx="3" fill="#ECEFF3" />
      <rect x="413" y="535" width="32" height="19" rx="3" fill="#ECEFF3" />
      <rect x="504" y="535" width="32" height="19" rx="3" fill="#ECEFF3" />
    </svg>
  );
}
